const cityToggleConfig = cityId => ({
  excludeCitiesFromValueProposition: ['milan', 'rome', 'florence'].includes(
    cityId
  ),
  showFeeOffer: [].includes(cityId),
  isInSpain: ['madrid', 'barcelona', 'valencia'].includes(cityId),
  showPriceIndexTooltip: ['barcelona'].includes(cityId),
  isNoDepositSupported: [
    'barcelona',
    'berlin',
    'brussels',
    'dublin',
    'florence',
    'lisbon',
    'london',
    'madrid',
    'milan',
    'paris',
    'porto',
    'rome',
    'valencia',
    'vienna'
  ].includes(cityId),
  isCoreCity: [
    'barcelona',
    'berlin',
    'brussels',
    'dublin',
    'florence',
    'lisbon',
    'london',
    'madrid',
    'milan',
    'paris',
    'porto',
    'rome',
    'valencia',
    'vienna'
  ].includes(cityId),
  isTenantFeeExperimentCity: [
    'barcelona',
    'berlin',
    'brussels',
    'dublin',
    'lisbon',
    'madrid',
    'milan',
    'paris',
    'rome',
    'valencia'
  ].includes(cityId)
});

export default cityToggleConfig;
